import type { EditorAPI } from '@/editorAPI';
import type { PresetSection } from './types';
import { addPanelUtils } from '@/addPanelInfra';

export const createPresetSectionAPI = (editorAPI: EditorAPI) => {
  return {
    async add(section: PresetSection) {
      return addPanelUtils.attemptToAddComponent(
        editorAPI,
        section.props.items[0].structure,
        '',
        section.title,
      );
    },
  };
};
